<template>
  <help-dialog title="Entities">
    <template #default>
      <h3 class="mb-1 text-black">
        <span class="bg-grey-lighten-3">Entities</span>
      </h3>
      <p class="text-grey-darken-3">
        <b>Entities</b> Entities represent the objects used by both the Read Models and the Commands.
        Each command should have one entity designated as the <b>Aggregate Root</b>, serving as
        the primary entity that a command operates on. The Aggregate Root often connects to
        related entities that provide additional context or details. Entities can be:
      </p>
      <br />
      <ul class="ml-5">
        <li>
          <b>Aggregate Root:</b>&nbsp;The main entity being accessed, created, updated, or deleted by a command.
        </li>
        <li><b>Related or Associated Entities:</b>&nbsp;Entities connected to the Aggregate Root.
        </li>
      </ul>
      <br />
      <p class="text-grey-darken-3">
        Read Models can also be linked to entities, as they serve to retrieve and present data in response to queries.
      </p>
      <br /><br />
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>

<style scoped>
.write-model {
  background-color: var(--blue-2);
}
</style>
